import { List, ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";
import SaveFreeTextMappingKeywordCommand from "./SaveFreeTextMappingKeywordCommand";

@NeoModel
export default class UpdateFreeTextMappingCommand extends ModelBase {

    public rawGenericServiceProviderEventMappingId: number = 0;
    
    public staticServiceProviderFileGroupingId: number = 0;

    public destinationFieldId: number = 0;

    @Rules.Required()
    @Rules.StringLength(100)
    public rawSourceFieldIncludes: string = "";

    @Rules.StringLength(100)
    public rawSouceFieldExcludes: string | null = null;

    @Rules.Required()
    @Rules.StringLength(100)
    public rawDestinationEventType: string = "";

    @Rules.StringLength(100)
    public rawDestinationCorporateActionType: string | null = null;

    public isPositiveValueInd: boolean | null = null;

    public rawGenericServiceProviderEventKeywords = new List(SaveFreeTextMappingKeywordCommand);
}